import { forwardRef } from 'react';
import classNames from 'classnames';

const RadioField = forwardRef(({ field, groupName, value, currentValue, onChange, style, radioStyle = 'dot', showBorder = true, borderColor = '#666' }, ref) => {
  const isChecked = currentValue === value;

  const handleClick = () => {
    onChange(groupName, value);
  };

  // Render the mark based on radioStyle
  const renderMark = () => {
    if (!isChecked) return null;
    
    switch (radioStyle) {
      case 'dot':
        return (
          <div style={{
            width: '60%',
            height: '60%',
            borderRadius: '50%',
            backgroundColor: '#000'
          }} />
        );
      case 'tick':
        return <span style={{ fontSize: '14px', fontWeight: 'bold' }}>✓</span>;
      case 'x':
        return <span style={{ fontSize: '14px', fontWeight: 'bold' }}>✕</span>;
      default:
        return (
          <div style={{
            width: '60%',
            height: '60%',
            borderRadius: '50%',
            backgroundColor: '#000'
          }} />
        );
    }
  };

  return (
    <div
      ref={ref}
      className={classNames('pdf-radio-field', `radio-${radioStyle}`, { checked: isChecked })}
      onClick={handleClick}
      style={{
        position: 'absolute',
        ...style,
        cursor: 'pointer',
        border: style.border || (showBorder ? `1px solid ${borderColor}` : 'none'),
        borderRadius: radioStyle === 'dot' ? '50%' : '0',
        backgroundColor: showBorder ? '#fff' : 'transparent',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0
      }}
    >
      {renderMark()}
    </div>
  );
});

RadioField.displayName = 'RadioField';

export default RadioField;
